import React from 'react';
import { useHistory } from 'react-router-dom';

import {
  IMG_IPFS_HOST,
  REACT_APP_IMAGES_PUBLIC_URL,
  RARITY_ICONS,
  isMobileDevice
} from '../../../../config';
import utils from '../../../../utils';

import { ReactComponent as WhiteCards } from '../../../../img/svg/Assets/CardsWhite.svg';
import { ReactComponent as AudioIcon } from '../../../../img/svg/Others/audio-icon.svg';
import { ReactComponent as MuteIcon } from '../../../../img/svg/Others/mute-icon.svg';

const ua = navigator.userAgent.toLowerCase();
const isSafari = ua.indexOf('safari') > -1 && ua.indexOf('chrome') < 0;

function NFTBuckCard({
  data = {},
  addToCart = () => {},
  fromPath = '/MarketHub',
  showQuantity = false,
  cardImageOnly = false,
  viewInCollection = false
}) {
  const {
    _id = '',
    title = '',
    imageFilePreview = '',
    imagePath = '',
    videoUrl = '',
    creatorName = '',
    supply = 0,
    supplyMinted = 0,
    lockedBuckQuantity = 0,
    marketPrice = 0,
    denomination = 0,
    isSold = 0,
    bucksStatus = '',
    rejectionCategory = '',
    quantity = 1,
    active = 0,
    activeAdbuck = false,
    showInMarketPlace = false,
    collectionDetail = '',
    rarityClass = ''
  } = data;
  const history = useHistory();
  const [videoPlaying, setVideoPlaying] = React.useState(false);
  const [muted, setMuted] = React.useState(true);
  const video = document.getElementById('buck-video-' + _id);
  const videoRef = React.useRef();

  React.useEffect(() => {
    if (isMobileDevice) {
      const handleClickOutside = (event) => {
        if (videoRef.current && !videoRef.current.contains(event.target)) {
          setVideoPlaying(false);
        }
      };
      document.addEventListener('click', handleClickOutside, true);
    }
    return () => {
      document.removeEventListener('click', () => {});
    };
  }, []);

  React.useEffect(() => {
    if (video) {
      if (isSafari || video.readyState === 4) {
        if (videoPlaying) video.play();
        else video.pause();
      }
    }
  }, [videoPlaying]);

  const redirectToBuckDetailLink = () => {
    try {
      if (!data?._id) return;
      let obj = { buckId: data._id, fromPath: fromPath };
      if (fromPath === '/StakeHub') {
        obj.quantity = quantity;
        obj.buyerWalletId = data.buyerWalletId;
      }
      if (rarityClass === 'adbuck') obj.isAdbuck = true;
      const cipherTextId = utils.getEncrypted(obj);
      history.push('/BuckDetails/' + cipherTextId);
    } catch (e) {
      console.log(e);
    }
  };

  const createBuckDetailByCollectionLink = () => {
    try {
      if (!data?._id) return;
      const obj = { collectionId: collectionDetail, fromPath: fromPath };
      const cipherTextId = utils.getEncrypted(obj);
      return '/CollectionDetails/' + cipherTextId;
    } catch (e) {
      return '/';
    }
  };

  return (
    <div className="buck-main-card-wrapper">
      <div
        className="buck-image-wrapper"
        onMouseEnter={() =>
          setVideoPlaying(videoUrl && !isMobileDevice ? true : false)
        }
        onMouseLeave={() => setVideoPlaying(false)}
        onClick={() =>
          !videoUrl || videoPlaying
            ? redirectToBuckDetailLink()
            : setVideoPlaying(true)
        }
      >
        <div className={`buck-main-image${videoUrl ? ' disabled-hover' : ''}`}>
          {rarityClass === 'adbuck' && bucksStatus !== 'approved' ? (
            <img
              className="adbuck-overlay"
              alt=""
              src={REACT_APP_IMAGES_PUBLIC_URL + '/overlays/Adbuck/AdBuck.webp'}
            ></img>
          ) : null}
          <img
            src={
              imageFilePreview
                ? imageFilePreview
                : imagePath
                ? IMG_IPFS_HOST + imagePath
                : REACT_APP_IMAGES_PUBLIC_URL + '/CreatorHub/default-buck.png'
            }
            className="w-100 h-100"
            alt=""
          />
          {videoUrl !== '' && (
            <div
              ref={videoRef}
              className="buck-video"
              style={videoPlaying ? {} : { zIndex: -1 }}
            >
              <div
                className="buck-video"
                dangerouslySetInnerHTML={{
                  __html: `<video src="${videoUrl}" muted loop disablePictureInPicture playsinline className="buck-video" width="100%" height="100%" id="buck-video-${_id}" />`
                }}
              />
              <span
                className={'audio-icon' + (muted ? ' audio-off' : '')}
                onClick={(e) => {
                  if (video) {
                    e.stopPropagation();
                    video.muted = !muted;
                    setMuted(!muted);
                  }
                }}
              >
                {!muted ? <MuteIcon /> : <AudioIcon />}
                {!muted ? '' : 'UN'}MUTE AUDIO
              </span>
            </div>
          )}
          {isSold > 0 && !cardImageOnly && fromPath === '/MarketHub' && (
            <div className="sold-out-ribbon">
              <span>SOLD OUT</span>
            </div>
          )}
          {activeAdbuck && (
            <div className="active-adbuck-ribbon">
              <span>Active AdBuck</span>
            </div>
          )}
        </div>
        {cardImageOnly ? null : bucksStatus === 'rejected' ? (
          <div className="onhover-buck-card-wrapper-rejected">
            <div className="text-white d-flex flex-column justify-content-center align-items-center">
              <p className="reject-text">Buck Rejected</p>
              <img
                src={
                  require('../../../../img/svg/Circle/RejectCircle.svg').default
                }
                alt=""
                className="alert-white"
              />
              <p className="rejection-details">
                {rejectionCategory}
                <br />
                <p className="text-decoration-underline text-center px-4">
                  Please edit and submit again.
                </p>
              </p>
            </div>
          </div>
        ) : !videoUrl && bucksStatus === 'created' ? (
          <div className="onhover-buck-card-wrapper">
            <img
              src={require('../../../../img/svg/Time/Time.svg').default}
              alt=""
              className="alert-white"
            />
            <div className="cursor-pointer">
              <h5 className="mt-2 text-gray">Approval pending</h5>
              <h6 className="text-gray text-decoration-underline text-center">
                View details
              </h6>
            </div>
          </div>
        ) : videoUrl ? null : (
          <div className="onhover-buck-card-wrapper">
            <img
              src={
                require('../../../../img/svg/Actions/AlertWhite.svg').default
              }
              alt=""
              className="alert-white"
            />
            <p className="click-for-details">Click for Buck Detail</p>
          </div>
        )}
      </div>
      {!cardImageOnly && (
        <>
          {fromPath === '/CreatorHub' && (
            <div className="buck-details-bottom mt-2">
              {rarityClass === 'adbuck' ? (
                <span className="text-gray">Unlimited</span>
              ) : bucksStatus === 'rejected' ? (
                <span className="text-gray">---</span>
              ) : (
                <span className={supply === 0 ? 'text-pink' : 'text-green'}>
                  {supply - supplyMinted - lockedBuckQuantity} left
                </span>
              )}
              <span className="d-flex">
                {bucksStatus === 'rejected' ? (
                  <span className="text-pink">Rejected</span>
                ) : bucksStatus === 'created' ? (
                  <span className="text-blue">Pending</span>
                ) : supply === 0 ? (
                  <span className="text-pink">Sold out</span>
                ) : active === 1 ? (
                  <span className="text-green">
                    {showInMarketPlace ? 'Live' : 'Active'}
                  </span>
                ) : (
                  <span className="text-pink">Inactive</span>
                )}
              </span>
            </div>
          )}
          {fromPath === '/StakeHub' && (
            <div className="d-flex justify-content-between mt-2">
              <p className="text-blue mb-0">{creatorName}</p>
              <span>{RARITY_ICONS[rarityClass.replace('-', '')]}</span>
            </div>
          )}
          <div className="buck-main-title two-line-title">{title}</div>
          {(fromPath !== '/MarketHub' || showQuantity) && (
            <div className="buck-details-wrapper">
              <p className="price-text mb-0 text-blue">
                ${fromPath !== '/StakeHub' ? marketPrice : denomination}
              </p>
              {showQuantity && (
                <p className="mb-2 text-white">
                  <WhiteCards />
                  &nbsp;&nbsp;{quantity}
                </p>
              )}
            </div>
          )}
          {fromPath === '/MarketHub' && !showQuantity && (
            <div className="buck-details-wrapper">
              <p className="nickname-text">{creatorName}</p>
              <p className="left-text">{supply} left</p>
            </div>
          )}
          <div className="divider-bottom" />
          {fromPath === '/MarketHub' && !showQuantity ? (
            <div className="buck-details-bottom mt-3 mb-1">
              <p className="price-text mb-0">${marketPrice}</p>
              {isSold ? (
                <button className="button-sold-out">SOLD OUT</button>
              ) : (
                <button
                  onClick={() =>
                    active !== 1
                      ? redirectToBuckDetailLink()
                      : addToCart(_id ? { ...data, type: 'buck' } : null)
                  }
                  className="button-add-to-cart"
                >
                  {active !== 1 ? 'View Buck' : 'Add to Cart'}
                </button>
              )}
            </div>
          ) : fromPath === '/CreatorHub' &&
            viewInCollection &&
            rarityClass !== 'adbuck' ? (
            <div className="buck-details-bottom mt-3 mb-1">
              <button
                onClick={() => history.push(createBuckDetailByCollectionLink())}
                className="button-view-in-collection"
              >
                View in Collection
              </button>
            </div>
          ) : (
            <div className="buck-details-bottom mt-3 mb-1">
              <button
                onClick={() => history.push(redirectToBuckDetailLink())}
                className="button-view-in-collection"
              >
                {rarityClass === 'adbuck'
                  ? 'View AdBuck'
                  : fromPath === '/StakeHub'
                  ? 'View Details'
                  : 'View NFT Buck'}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default NFTBuckCard;
